export const getIsRelativeUrl = (url: string) => {
  if (!url) return false
  return url.startsWith('/') && !url.startsWith('//')
}
